<div class="container">
  <div class="newRow" style="min-height: 400px">
    <h2 style="text-align: center;line-height: 400px;">Страница не найдена</h2>
  </div>
</div>
